import { ApplicationState } from '../reducers/index'

export const getApplicationRoles = (state: ApplicationState) =>
  state.applicationRoles.items
